// web/src/routes/RootLayout.tsx
// App-root layout: renders the matched route plus the always-present <IgnitionOverlay>, so
// the completion transition survives the Processing → Player navigation (it lives above the
// route being swapped). The overlay is inert (pointer-events-none, opacity 0) until triggered.
import type { JSX } from "react";
import { Outlet } from "react-router-dom";
import { IgnitionOverlay } from "@/components/IgnitionOverlay";
import { CustomCursor } from "@/components/CustomCursor";

export default function RootLayout(): JSX.Element {
  return (
    <>
      <Outlet />
      <IgnitionOverlay />
      <CustomCursor />
    </>
  );
}
